import React, { useState, useEffect } from 'react';
import { Spin, Typography, Button } from 'antd';
import { MailOutlined } from '@ant-design/icons';
import { useAuth } from '../store/auth';

const { Title, Text } = Typography;

const MailPage = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    const token = localStorage.getItem('access_token');
    if (token) {
      document.cookie = `erp_token=${token}; path=/; domain=.spzvg.ru; secure; samesite=lax`;
    }
    setLoading(false);
  }, []);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 200px)' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 40, textAlign: 'center' }}>
        <Title level={4}>Ошибка загрузки почты</Title>
        <Text type="secondary">{error}</Text>
        <br /><br />
        <Button type="primary" href="https://webmail.spzvg.ru" target="_blank">
          Открыть почту в новой вкладке
        </Button>
      </div>
    );
  }

  return (
    <div style={{ height: 'calc(100vh - 150px)', margin: '-24px', borderRadius: 16, overflow: 'hidden', background: '#fff' }}>
      <iframe 
        src="/webmail/"
        style={{ width: '100%', height: '100%', border: 'none' }}
        title="Roundcube Webmail"
        allow="clipboard-read; clipboard-write"
      />
    </div>
  );
};

export default MailPage;
